import React, { useState, useCallback } from 'react';
import { Container, Content, Col, QuestionStyle } from 'pages/new-questions/styles/common';
import { ContextQuestionProps } from './utils/types';
import { useContextQuestionState } from './hooks/useContextQuestionState';
import {
  QuestionHeader,
  AnswerTextArea,
  EvaluationResult,
  SubmitFooter,
  DisagreeButton,
  DisagreeModal,
} from './components';
import { useQuestionResolution } from '../../hooks/useQuestionResolution';
import { QuestionResolutionModals } from '../QuestionResolutionModals';

const ContextQuestion: React.FC<ContextQuestionProps> = ({
  question,
  isTest = false,
  questionNumber,
  totalQuestions,
  Header,
  BackButton,
  handleSubmit,
  setText,
  answeredAnswer,
  resolved,
  provaId,
}) => {
  const {
    questionTextShow,
    setQuestionTextShow,
    questionVideoStart,
    setQuestionVideoStart,
    modalVideoOption,
    setModalVideoOption,
    isLibrasVideo,
    setIsLibrasVideo,
    handlePlayVideo,
    handleReadResolution,
    formulaModalShow,
    setFormulaModalShow,
    handleShowFormula,
  } = useQuestionResolution({ hasLibrasVideo: !!question.video_embed_libras });

  const { state, handleTextChange, handleSubmitContext } = useContextQuestionState({
    question,
    answeredAnswer,
    resolved,
    setText,
    handleSubmit,
  });

  const [isDisagreeModalOpen, setIsDisagreeModalOpen] = useState(false);
  const [submittedQuestions, setSubmittedQuestions] = useState<Set<number>>(new Set());

  const handleDisagreeSuccess = useCallback(() => {
    setSubmittedQuestions(prev => new Set(prev).add(question.id_questao));
  }, [question.id_questao]);

  const isDisagreeSubmitted = submittedQuestions.has(question.id_questao);

  const { case_context, question: questionText } = question;

  return (
    <Container isTest={isTest}>
      <Content isTest={isTest}>
        {Header}
        <QuestionHeader
          questionNumber={questionNumber}
          totalQuestions={totalQuestions}
          caseCode={question?.code}
        />
        <Col padding="20px 24px 24px" width="100%">
          <QuestionStyle dangerouslySetInnerHTML={{ __html: case_context || '' }} />
          <QuestionStyle dangerouslySetInnerHTML={{ __html: questionText || '' }} />
          {!state.evaluationResult && (
            <AnswerTextArea
              value={state.answer}
              onChange={handleTextChange}
              disabled={state.isEvaluating}
            />
          )}
          {state.evaluationResult && (
            <EvaluationResult
              evaluationResult={state.evaluationResult}
              answer={state.answer}
              isEvaluating={state.isEvaluating}
            />
          )}
          {state.evaluationResult && !state.isEvaluating && (
            <DisagreeButton
              onClick={() => setIsDisagreeModalOpen(true)}
              disabled={isDisagreeSubmitted}
            />
          )}
        </Col>
        {!isTest && (
          <SubmitFooter
            BackButton={BackButton}
            onSubmit={handleSubmitContext}
            isSubmitting={state.isSubmitting}
            answerLength={state.answer.length}
            hasCommentedQuestion={!!question.questao_comentada}
            hasVideoEmbed={!!question.video_embed}
            hasFormula={!!question.formula || !!question.formula_imagem}
            onReadResolution={handleReadResolution}
            onWatchResolution={handlePlayVideo}
            onShowFormula={handleShowFormula}
          />
        )}
        <DisagreeModal
          questionId={question.id_questao}
          provaId={provaId}
          studentAnswer={state.answer}
          evaluationResult={state.evaluationResult}
          isOpen={isDisagreeModalOpen}
          onClose={() => setIsDisagreeModalOpen(false)}
          onSuccess={handleDisagreeSuccess}
        />
        <QuestionResolutionModals
          modalVideoOption={modalVideoOption}
          setModalVideoOption={setModalVideoOption}
          setIsLibrasVideo={setIsLibrasVideo}
          questionVideoStart={questionVideoStart}
          setQuestionVideoStart={setQuestionVideoStart}
          isLibrasVideo={isLibrasVideo}
          videoEmbed={question?.video_embed}
          videoEmbedLibras={question?.video_embed_libras}
          questionTextShow={questionTextShow}
          setQuestionTextShow={setQuestionTextShow}
          questaoComentada={question?.questao_comentada}
          formulaModalShow={formulaModalShow}
          setFormulaModalShow={setFormulaModalShow}
          formula={question?.formula}
          formulaImagem={question?.formula_imagem}
        />
      </Content>
    </Container>
  );
};

export default ContextQuestion;
